import { ColorCard } from '../../../../../../components/profile/Customize/ColorCard'
import { EditTheme } from '../../../../../../components/profile/Customize/types'
import { FC, useMemo } from 'react'
import { PageType } from '@dtx-company/flow-codegen/src/page/typeUtils'
import { ShadePicker } from '../../../../../../components/profile/Customize/ShadePicker'
import { Stack } from '@dtx-company/design-system/src'
import { defaultUserTheme } from '@dtx-company/true-common/src/constants/page'
import { getLockedFieldFromTemplateConfig } from '../../../../../FlowpageTemplates/utils/getLockedFieldFromTemplateConfig'
import { useEditThemeWithAutosave } from '../../../../../../components/profile/Customize/hooks'
import { usePageTemplateEditorState } from '@dtx-company/inter-app/src/hooks/usePageTemplateEditorState'

export const ColorMenu: FC<{ pageTheme: PageType['theme'] }> = ({ pageTheme }) => {
  const { __typename, ...curTheme } = pageTheme || defaultUserTheme
  const editTheme = useEditThemeWithAutosave()

  const handleSelect = (newTheme: EditTheme): void => {
    editTheme({
      themeInput: {
        ...curTheme,
        ...newTheme
      },
      themeId: curTheme.id
    })
  }
  const { isTemplateEditor } = usePageTemplateEditorState()

  const colorDisabled = useMemo(
    () =>
      !isTemplateEditor &&
      getLockedFieldFromTemplateConfig({
        templateConfig: pageTheme?.templateConfig,
        field: 'primaryColor'
      }),
    [isTemplateEditor, pageTheme?.templateConfig]
  )

  const styleDisabled = useMemo(
    () =>
      !isTemplateEditor &&
      getLockedFieldFromTemplateConfig({
        templateConfig: pageTheme?.templateConfig,
        field: 'style'
      }),
    [isTemplateEditor, pageTheme?.templateConfig]
  )

  return (
    <Stack
      sx={{
        pb: 4
      }}
      spacing={4}
    >
      <ColorCard
        disabled={colorDisabled}
        mobile
        curr={curTheme?.primaryColor || ''}
        handleSelect={handleSelect}
      />
      <ShadePicker
        curr={curTheme?.style ?? ''}
        color={curTheme?.primaryColor ?? ''}
        handleSelect={handleSelect}
        mobile
        disabled={styleDisabled}
      />
    </Stack>
  )
}
